export default __webpack_public_path__ + "static/media/weight-loss_person-on-scales.33bb8e4b.jpg";